import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const RackDetailPageRBAC = {
  pageID: 'bcd988006c14ba004164c3c0feb345a3',
  elementID: {
    BtnBulkUpload: '81234f80f1f46e5d6519d760db3f6b2a',
    BtnExportCSV: '82a4c27b02e7952bbe8fd42edb521011',
    BtnDeleteSingleRack: '10905bb547f3a5fc559da0bb8d10b705',
    BtnEditSingleRack: '974a2a456816814aa2383fbc709aad18',
    BtnBulkPrintBarcodeSLOC: 'e660f942ae366e7de867bbd86bec251d',
    BtnBulkDeleteRack: '05fff03b41a7525e0401113bcc64d849',
    BtnUpdateRackStatus: '45685e5a284b341da1e54ade5dafb2c1',
  },
} as const

export const useRBACRackDetailPage = createUseRBAC(RackDetailPageRBAC.elementID)

export type UseRBACRackDetailPageType = ReturnType<typeof useRBACRackDetailPage>
